<template>
  <div>    
    <section class="hero">
      <div class="hero-body is-flex is-justify-content-center is-align-items-center">
        <div class="card">
          <div class="card-content">
            <img src="/vector-login.png">
            <div class="content has-text-centered">
              <br>              
              <h4>Sorry!</h4>              
              <div v-html="messageMaintenance"></div>
            </div>
          </div>
        </div>
      </div>
    </section>    
  </div>
</template>

<script>
  export default {
    data() {
      return {
        messageMaintenance: 'Sorry! We are currently undergoing some scheduled maintenance.<br>We will be back soon, please try again shortly.'
      }
    },  

    mounted() {    
      var messageMaintenance = this.$store.state.messageMaintenance;
      if (messageMaintenance) { this.messageMaintenance = messageMaintenance; }
    }
  }
</script>
